module.exports = __webpack_public_path__ + "static/sanding-7b890ca520c169c82d805c508028b844.gif";